import React, { useState } from 'react'; 
import './AppointmentForm.css';

const AppointmentPage = () => {
  // State for form fields
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    course: '',
    phone: '',
    message: ''
  });

  const courseOptions = [
    "Heavy Motor Vehicle Training",
    "Light Motor Vehicle Training",
    "Motorcycle Training",
    "One Day Training Program",
    "DB Skill Course",
    "Saudi Arab Certification"
  ];

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, course, phone, message } = formData;
    
    // Email body formatting
    const subject = `New Appointment Request from ${name}`;
    const body = `
      Name: ${name}%0D%0A
      Email: ${email}%0D%0A
      Course Type: ${course}%0D%0A
      Phone: ${phone}%0D%0A
      Message: ${message}
    `;
    
    // Open email client
    window.location.href = `mailto:rdtcsingawal@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <div className="appointment-container">
      <div className="top-section">
        <div className="image-section">
          <div className="image-container">
            <img src="/images/IMG-20241112-WA0019.jpg" alt="Main" className="main-img" />
            <div className="overlay-image">
              <img src="/images/IMG-20241112-WA0017.jpg" alt="Overlay" className="overlay-img" />
            </div>
          </div>
        </div>

        <div className="appointment-section">
          <h2>APPOINTMENT</h2>
          <p>Make a booking appointment</p>
          <form onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
            <input type="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} required />
            <select name="course" value={formData.course} onChange={handleChange} required>
              <option value="">Select Course Type</option>
              {courseOptions.map((option, index) => (
                <option key={index} value={option}>{option}</option>
              ))}
            </select>
            <input type="text" name="phone" placeholder="Phone No." value={formData.phone} onChange={handleChange} required />
            <textarea name="message" placeholder="Message" rows="3" value={formData.message} onChange={handleChange}></textarea>
            <button type="submit">Submit</button>
          </form>
        </div>
      </div>

      <div className="certificates-section">
        <h3>Certificates Awarded</h3>
        <div className="certificates-container">
          <img src="/images/IMG_9847.jpg" alt="Certificate 1" />
          <img src="/images/cer1.png" alt="Certificate 2" />
          {/* <img src="/images/img3.jpg" alt="Certificate 3" /> */}
        </div>
      </div>
    </div>
  );
};

export default AppointmentPage;